import styled from 'styled-components';

export default styled.ul`
 font-family: 'Galano Classic';
 width: 40vw;
 margin-bottom: 7rem;
`;
